import { render } from "./HowToOrder.vue?vue&type=template&id=b681e35e&scoped=true"
import script from "./HowToOrder.vue?vue&type=script&lang=js"
export * from "./HowToOrder.vue?vue&type=script&lang=js"

import "./HowToOrder.vue?vue&type=style&index=0&id=b681e35e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b681e35e"]])

export default __exports__